<template>
  <div>

    <router-view />
  </div>
</template>
<script >
import BreadcrumbHeader from "../components/template/_template-breadcrumb-header";

export default {
  name: "SelfAssessment",
  components: { BreadcrumbHeader },
};
</script >
<style lang="scss" >
.modal{
  text-align: center;
  .modal-title{
    width: 100%;
  }
}
</style >
